import { GenericStatus, GenericStatusColorType } from '@hevoio/hevo-ui-toolkit';
import { VPCPeeringStatus, VPCPeeringStatusValue } from '../interface';

const STATUS_DATA_MAP: Record<VPCPeeringStatusValue, GenericStatus<string>> = {
  [VPCPeeringStatusValue.ACTIVE]: {
    value: VPCPeeringStatusValue.ACTIVE,
    displayName: 'Available',
    icon: 'circle-tick',
    colorType: GenericStatusColorType.SUCCESS
  },
  [VPCPeeringStatusValue.PENDING]: {
    value: VPCPeeringStatusValue.PENDING,
    displayName: 'Pending',
    icon: 'error-outline',
    colorType: GenericStatusColorType.WARNING
  },
  [VPCPeeringStatusValue.PENDING_ACCEPTANCE]: {
    value: VPCPeeringStatusValue.PENDING_ACCEPTANCE,
    displayName: 'Pending Acceptance',
    icon: 'error-outline',
    colorType: GenericStatusColorType.INFO
  },
  [VPCPeeringStatusValue.REQUEST_SUBMITTED]: {
    value: VPCPeeringStatusValue.REQUEST_SUBMITTED,
    displayName: 'Request Submitted',
    icon: 'error-outline',
    colorType: GenericStatusColorType.WARNING
  },
  [VPCPeeringStatusValue.FAILED]: {
    value: VPCPeeringStatusValue.FAILED,
    displayName: 'Failed',
    icon: 'error-outline',
    colorType: GenericStatusColorType.ERROR
  },
  [VPCPeeringStatusValue.DELETED]: {
    value: VPCPeeringStatusValue.DELETED,
    displayName: 'Deleted',
    icon: 'trash',
    colorType: GenericStatusColorType.DISABLED
  }
};

export const getPeeringStatus = (status?: VPCPeeringStatus): GenericStatus<string> =>
  STATUS_DATA_MAP[status?.value] ?? {
    value: status?.value ?? '',
    displayName: status?.name ?? status?.value ?? '',
    colorType: GenericStatusColorType.DEFAULT
  };

// Only ACTIVE has a background change worth narrating — a live route-table
// update that leaves the connection serving traffic throughout. Every other
// in-flight state already says so in the status itself.
const IN_PROGRESS_LABEL: Partial<Record<VPCPeeringStatusValue, string>> = {
  [VPCPeeringStatusValue.ACTIVE]: 'Updating routes…'
};

export const getInProgressLabel = (status?: VPCPeeringStatus): string | undefined =>
  IN_PROGRESS_LABEL[status?.value];
